import store from '@/store';

export default class RemoveWhatsAppInboxEvent {
  constructor(event) {
    const protocol = event.body.protocol;
    if (protocol) {
      store.dispatch('jobs/removeInboxJob', protocol);
    }
  }
}
